import React, { useEffect, useState } from "react";
import { EditPage } from "@equipedigitalfloripa/ed-cms/components";
//import { fetchCasino, editCasino, uploadCasino } from '../api/casinos'
import * as contentsApi from "../api/content";
import { fetchItems as getLocations } from "../api/location";

const EditContent = ({ edit }) => {
  const selectedData = [
    {
      name: "_id",
      type: "hidden",
      title: "Id",
    },
    {
      name: "title",
      type: "text",
      title: "Título conteúdo",
      validation: {
        required: true,
      },
    },
    {
      name: "SEO_tags",
      type: "text",
      title: "Tags SEO (separadas por vírgula)",
    },
    {
      name: "content",
      type: "tiny",
      title: "Conteúdo ",
    },
  ];
  return (
    <EditPage
      title={"Página de conteúdo"}
      subtitle={""}
      selectedData={selectedData}
      fetchFunction={contentsApi.fetchItem}
      editFunction={contentsApi.editItem}
      edit={edit}
      url="contents"
    />
  );
};

export default EditContent;
